import SuccessBadge from './SuccessBadge'

export default SuccessBadge
